import React from 'react';

const useOutsideClick = (ref, flag, callback) => {
    React.useEffect(() => {
        const handler = (event) => {
            if (flag && !ref.current?.contains(event.target)) callback();
        };
        document.addEventListener('click', handler, true);
        return () => document.removeEventListener('click', handler, true);
    }, [ref, flag, callback]);
};

export default useOutsideClick;
